import { useTranslation } from 'react-i18next';

/**
 * DSP包裹状态国际化Hook
 * 用于将DSP包裹状态转换为本地化文本
 */
export const useDspStatusInternationalization = () => {
    const { t } = useTranslation();

    /**
     * 获取DSP包裹状态的本地化文本
     * @param status 状态值，对应OverallStatus枚举名称
     * @returns 本地化的状态文本
     */
    const getStatusText = (status: string | undefined): string => {
        if (!status) return '-';
        
        switch (status) {
            case 'CREATED': return t('enum.overallStatus.CREATED');
            case 'CANCELLED': return t('enum.overallStatus.CANCELLED');
            case 'ARRIVED_ORIGIN_HUB': return t('enum.overallStatus.ARRIVED_ORIGIN_HUB');
            case 'PENDING_SHIPMENT': return t('enum.overallStatus.PENDING_SHIPMENT');
            case 'HANDED_OVER': return t('enum.overallStatus.HANDED_OVER');
            case 'IN_TRANSIT': return t('enum.overallStatus.IN_TRANSIT');
            case 'ARRIVED_DESTINATION_HUB': return t('enum.overallStatus.ARRIVED_DESTINATION_HUB');
            case 'ARRIVED_WHS': return t('enum.overallStatus.ARRIVED_WHS');
            case 'WAITING_FOR_DELIVERY': return t('enum.overallStatus.WAITING_FOR_DELIVERY');
            case 'DELIVERY_IN_PROGRESS': return t('enum.overallStatus.DELIVERY_IN_PROGRESS');
            case 'DELIVERED': return t('enum.overallStatus.DELIVERED');
            case 'DELIVERY_FAILED': return t('enum.overallStatus.DELIVERY_FAILED');
            case 'PENDING_INTERCEPTION': return t('enum.overallStatus.PENDING_INTERCEPTION');
            case 'INTERCEPTED': return t('enum.overallStatus.INTERCEPTED');
            case 'RETURN_STARTED': return t('enum.overallStatus.RETURN_STARTED');
            case 'RETURNED': return t('enum.overallStatus.RETURNED');
            case 'HOLDING': return t('enum.overallStatus.HOLDING');
            case 'RETURN_ARRIVED_DESTINATION_HUB': return t('enum.overallStatus.RETURN_ARRIVED_DESTINATION_HUB');
            case 'PICKUP_FAILED': return t('enum.overallStatus.PICKUP_FAILED');
            case 'DESTROYED': return t('enum.overallStatus.DESTROYED');
            case 'MISSING': return t('enum.overallStatus.MISSING');
            case 'DAMAGED': return t('enum.overallStatus.DAMAGED');
            default: return String(status);
        }
    };

    /**
     * 获取DSP包裹状态对应的颜色
     * @param status 状态值
     * @returns 对应的颜色类型
     */
    const getStatusColor = (status: string | undefined): 'success' | 'primary' | 'warning' | 'danger' | 'default' => {
        if (!status) return 'default';
        
        switch (status) {
            case 'DELIVERED':
                return 'success';
            case 'DELIVERY_IN_PROGRESS':
            case 'WAITING_FOR_DELIVERY':
            case 'IN_TRANSIT':
                return 'primary';
            case 'DELIVERY_FAILED':
            case 'PICKUP_FAILED':
                return 'danger';
            case 'CANCELLED':
            case 'INTERCEPTED':
            case 'HOLDING':
                return 'warning';
            default:
                return 'default';
        }
    };

    /**
     * 根据后端返回的英文名称获取下一步动作的国际化文本
     * @param backendName 后端返回的英文名称
     * @returns 国际化后的动作文本
     */
    const getNextActionTextFromBackend = (backendName: string): string => {
        switch (backendName) {
            case 'None': return t('config.nextAction.None');
            case 'Hold': return t('config.nextAction.Hold');
            case 'ReDeliver': return t('config.nextAction.ReDeliver');
            case 'Return': return t('config.nextAction.Return');
            case 'Compensate': return t('config.nextAction.Compensate');
            case 'ReSort': return t('config.nextAction.ReSort');
            default: return backendName;
        }
    };

    return {
        getStatusText,
        getStatusColor,
        getNextActionTextFromBackend
    };
};
